import { Component, inject } from '@angular/core';
import { Digitize } from './digitize/digitize';
import { Characteristics } from './characteristics/characteristics';
import { How } from './how/how';
import { Contact } from './contact/contact';
import { Table } from './table/table';
import { Questions } from './questions/questions';
import { Sponsors } from './sponsors/sponsors';
import { Hero } from './hero/hero';
import { Nav } from './nav/nav';
import { Footer } from './footer/footer';
import { ViewportScroller } from '@angular/common';
import { SuportButtonComponent } from '@shared/components/suport-button/suport-button.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-principal',
  standalone: true,
  imports: [Hero, Sponsors, Questions, Table, Contact, How, Characteristics, Digitize, Nav, Footer, SuportButtonComponent],
  templateUrl: './principal.component.html',
  styleUrl: './principal.component.scss'
})
export class PrincipalComponent {
  private route = inject(ActivatedRoute);
  router = inject(Router);

  constructor(private scroller: ViewportScroller) {}

    ngOnInit(): void {
    scroll(0,0)
    this.scroller.setOffset([0, 80]);

     //redireccionar si viene con un intent en la url
        this.deepLinking();
  }

  deepLinking() {
        let code = this.route.snapshot.queryParamMap.get('code') || '';
        let intent = this.route.snapshot.queryParamMap.get('intent') || '';
        switch (intent) {
            case 'validate':
              this.router.navigate(['/auth/validate/' + code]);
              break;
            case 'recovery-password':
              this.router.navigate([
                '/auth/reset-pwd/' + code
              ]);
              break;
          }
    }

  
}
